import register from '../util/register'
import angular from 'angular'
import DetailResultController from './DetailResultController'
import DetailResultService from './DetailResultService'
import SubscriptionService from '../billing/SubscriptionService'
import SearchParametersService from '../search-form/SearchParametersService'
import MonthlyProductionService from './MonthlyProductionService'
import MonthlyProduction from './MonthlyProduction.resource'
import OseDetail from './OseDetail.directive'
import OseDownloadAll from './OseDownloadAll.directive'
import OseRelatedDocuments from './OseRelatedDocuments.directive'
import OseRespondents from './OseRespondents.directive'
import '../records/records.module.js'
import './monthly-production-details/monthly-production-details.module'

var detailResult = angular.module(
  'app.detailResult',
  [
    'app.records',
    'app.monthlyProductionDetails'
  ]
)

register('app.detailResult')
  .service('DetailResultService', DetailResultService)
  .service('SearchParametersService', SearchParametersService)
  .service('SubscriptionService', SubscriptionService)
  .service('MonthlyProductionService', MonthlyProductionService)
  .controller('DetailResultController', DetailResultController)
  .directive('oseDetail', OseDetail)
  .directive('oseDownloadAll', OseDownloadAll)
  .directive('oseRelatedDocuments', OseRelatedDocuments)
  .directive('oseRespondents', OseRespondents)
  .factory('MonthlyProduction', MonthlyProduction.factory)

detailResult.run()